import Cookies from "js-cookie";

import {
  COOKIE_PREFIX,
  COOKIE_ROLE,
  COOKIE_SESSION_TOKEN,
  NOT_VALID_VALUES,
  cookieENV,
  getCookieOptions,
  isLocal,
  isTest,
} from "constants/env-constants";

const options = getCookieOptions();

const validStorageValue = (value: string, cb: CallableFunction) => {
  if (NOT_VALID_VALUES.includes(value)) return;
  cb();
};

const cookieStorage = {
  setItem: (key: string, value: string): void => {
    validStorageValue(value, () => {
      Cookies.set(key, value, options);
    });
  },
  removeItem: (key: string): void => Cookies.remove(key, options),
  getItem: (key: string): string => Cookies.get(key) || "",
  getToken: (): string => {
    const env = cookieENV();
    const id =
      !isTest() && !isLocal()
        ? `${COOKIE_PREFIX}${env}-${COOKIE_SESSION_TOKEN}`
        : `${env}-${COOKIE_SESSION_TOKEN}`;
    return Cookies.get(id) || "";
  },
  getRole: (): string => {
    const env = cookieENV();
    const id =
      !isTest() && !isLocal() ? `${COOKIE_PREFIX}${env}-${COOKIE_ROLE}` : `${env}-${COOKIE_ROLE}`;
    return Cookies.get(id) || "";
  },
};

export default cookieStorage;
